module.exports = __webpack_public_path__ + "static/media/locateplus.636870e9.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/locateplus.ico
// module id = 1908
// module chunks = 0